import { Routes } from '@angular/router';
import { ReportComponent } from './report/report.component';

export const routes: Routes = [

    //{ path: 'report', loadComponent: () => import('./report/report.component').then(m => m.ReportComponent) }
    { path: '', redirectTo: 'report', pathMatch: 'full' }, // Redirect to ReportComponent
    { path: 'report', component: ReportComponent } // Route for ReportComponent
];
